import type { ProductLogoSmallProps } from "../types";

export function ProductLogoSmallBusinessPartner({
  size = 20,
  color = "#00BE64",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342 50C355.255 50 366 60.7452 366 74V122H414C427.255 122 438 132.745 438 146V326C438 339.255 427.255 350 414 350H369.175C357.958 299.223 314.58 260.527 261.497 256.371C281.456 241 296.179 219.165 302.534 194H322C326.418 194 330 190.418 330 186V166C330 161.582 326.418 158 322 158H305.722C304.772 144.304 301.404 131.275 296.041 119.336C297.506 120.971 299.632 122 302 122H322C326.418 122 330 118.418 330 114V94C330 89.5817 326.418 86 322 86H302C297.582 86 294 89.5817 294 94V114C294 114.414 294.031 114.821 294.092 115.219C285.693 98.3658 273.244 83.8852 258.02 73.0518C258.517 60.2365 269.063 50 282 50H342ZM302 230C297.582 230 294 233.582 294 238V258C294 262.418 297.582 266 302 266H322C326.418 266 330 262.418 330 258V238C330 233.582 326.418 230 322 230H302ZM374 230C369.582 230 366 233.582 366 238V258C366 262.418 369.582 266 374 266H394C398.418 266 402 262.418 402 258V238C402 233.582 398.418 230 394 230H374ZM374 158C369.582 158 366 161.582 366 166V186C366 190.418 369.582 194 374 194H394C398.418 194 402 190.418 402 186V166C402 161.582 398.418 158 394 158H374Z"
        fill={color}
      />
      <path
        d="M155.332 280C153.191 284.9 152 290.311 152 296C152 307.375 156.748 317.64 164.37 324.923C159.146 331.171 156 339.218 156 348V400C156 404.208 156.725 408.246 158.052 412H60C46.7452 412 36 401.255 36 388V376C36 322.981 78.9807 280 132 280H155.332Z"
        fill={color}
      />
      <path
        d="M192 336C198.627 336 204 341.373 204 348V400C204 406.627 198.627 412 192 412C185.373 412 180 406.627 180 400V348C180 341.373 185.373 336 192 336Z"
        fill={color}
      />
      <path
        d="M252 280C305.019 280 348 322.981 348 376V388C348 401.255 337.255 412 324 412H225.948C227.275 408.246 228 404.208 228 400V348C228 339.218 224.854 331.171 219.629 324.923C227.251 317.64 232 307.375 232 296C232 290.311 230.809 284.9 228.668 280H252Z"
        fill={color}
      />
      <path
        d="M192 280C200.837 280 208 287.163 208 296C208 304.837 200.837 312 192 312C183.163 312 176 304.837 176 296C176 287.163 183.163 280 192 280Z"
        fill={color}
      />
      <path
        d="M192 76C241.706 76 282 116.294 282 166C282 215.706 241.706 256 192 256C142.294 256 102 215.706 102 166C102 116.294 142.294 76 192 76Z"
        fill={color}
      />
    </svg>
  );
}
